var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalogous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 298",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m240.909091 117c-32.635008 0-59.090909-26.1913421-59.090909-58.5s26.455901-58.5 59.090909-58.5 59.090909 26.1913421 59.090909 58.5-26.455901 58.5-59.090909 58.5zm-181.8181819 180c-32.635008 0-59.0909091-26.191342-59.0909091-58.5s26.4559011-58.5 59.0909091-58.5c32.6350079 0 59.0909089 26.191342 59.0909089 58.5s-26.455901 58.5-59.0909089 58.5zm181.8181819 0c-32.635008 0-59.090909-26.191342-59.090909-58.5s26.455901-58.5 59.090909-58.5 59.090909 26.191342 59.090909 58.5-26.455901 58.5-59.090909 58.5z",
    fillRule: "evenodd",
    transform: "translate(0 .5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalogous);
export default __webpack_public_path__ + "static/media/analogous.10031d66bc46a22718803c5bc47b5eb2.svg";
export { ForwardRef as ReactComponent };